export function renderTranslation(
  val: unknown,
): string | number | boolean | null {
  return typeof val === 'string' ||
    typeof val === 'number' ||
    typeof val === 'boolean'
    ? val
    : null;
}
